<form-workflow
  [form]="rsf"
  [sectionNumber]="6"
  [service]="service"
  [disabled]="disabled"
  [privilegeWoApproval]="privilegeEnum.RSFOpAppWoApproval"
  (signaturesCreated)="signaturesCreated($event)"
></form-workflow>
